import React from 'react';
import { useToolStore } from '../../store/useToolStore';
import { Globe, MapPin } from 'lucide-react';
import { MapPicker } from './MapPicker';

export const GeoGrounding: React.FC = () => {
    const { lensParams, setLensParams } = useToolStore();
    const updateParams = (updates: Partial<typeof lensParams>) => setLensParams({ ...lensParams, ...updates });
    const handleLocationSelect = (location: string) => updateParams({ location });

    return (
        <div className="space-y-4">
            <div className="bg-gray-800 p-4 rounded-lg space-y-4">
                <div className="space-y-2">
                    <label className="text-xs text-gray-400">Location</label>
                    {lensParams.showMap ? (
                        <MapPicker onLocationSelect={handleLocationSelect} initialLocation={lensParams.location} />
                    ) : (
                        <div className="relative">
                            <MapPin size={16} className="absolute left-3 top-2.5 text-gray-500" />
                            <input
                                type="text"
                                placeholder="e.g. Shibuya Crossing, Tokyo"
                                value={lensParams.location}
                                onChange={(e) => updateParams({ location: e.target.value })}
                                className="w-full bg-gray-900 border border-gray-700 rounded-lg py-2 pl-10 pr-4 text-sm text-gray-200 focus:outline-none focus:border-blue-500"
                            />
                        </div>
                    )}
                </div>
                <div className="flex items-center justify-between bg-gray-700 p-2 rounded">
                    <div className="flex items-center space-x-2">
                        <Globe size={14} className="text-blue-400" />
                        <span className="text-xs text-gray-300">Show Interactive Map</span>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input
                            type="checkbox"
                            checked={lensParams.showMap}
                            onChange={(e) => updateParams({ showMap: e.target.checked })}
                            className="sr-only peer"
                        />
                        <div className="w-9 h-5 bg-gray-600 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-500 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600"></div>
                    </label>
                </div>
            </div>
        </div>
    );
};
